/** Parsed exchange (mainai) metadata from offer message. */
export type ExchangeRoute = 'warehouse' | 'direct'

export type ExchangeOfferMeta = {
  offerKind: 'cash' | 'exchange'
  exchangeRoute?: ExchangeRoute
  offeredListingId?: number
  extraCash?: number
  note?: string
}

const EXCHANGE_PREFIX = '[EXCHANGE]'

function parseRoute(raw: string): ExchangeRoute | undefined {
  const m = /route=(warehouse|direct)/.exec(raw)
  return m ? (m[1] as ExchangeRoute) : undefined
}

export function parseExchangeOfferMessage(message: string | null | undefined): ExchangeOfferMeta {
  if (!message?.trim()) return { offerKind: 'cash' }
  const raw = message.trim()
  if (!raw.startsWith(EXCHANGE_PREFIX)) {
    return { offerKind: 'cash' }
  }
  const offeredMatch = /offered_listing_id=(\d+)/.exec(raw)
  const cashMatch = /extra_cash=([\d.]+)/.exec(raw)
  const noteMatch = /,\s*note=(.+)$/.exec(raw)
  const exchangeRoute = parseRoute(raw)
  if (!offeredMatch) {
    return { offerKind: 'exchange', exchangeRoute, note: raw }
  }
  return {
    offerKind: 'exchange',
    exchangeRoute,
    offeredListingId: parseInt(offeredMatch[1], 10),
    extraCash: cashMatch ? parseFloat(cashMatch[1]) : 0,
    note: noteMatch?.[1]?.trim() || undefined,
  }
}

export function buildExchangeOfferMessage(
  offeredListingId: number,
  extraCash: number,
  route: ExchangeRoute,
  note?: string,
): string {
  const base = `${EXCHANGE_PREFIX} route=${route} offered_listing_id=${offeredListingId}, extra_cash=${extraCash.toFixed(2)}`
  const trimmed = note?.trim()
  return trimmed ? `${base}, note=${trimmed}` : base
}
